import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Página no encontrada")
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "row justify-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "justify-center" }, "No se encontró el sitio que estaba buscando")
], -1)
const _hoisted_3 = { class: "row justify-center" }
const _hoisted_4 = { class: "justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_header = _resolveComponent("q-header")
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_q_page_container = _resolveComponent("q-page-container")
  const _component_q_layout = _resolveComponent("q-layout")

  return (_openBlock(), _createBlock(_component_q_layout, { view: "lHh Lpr lFf" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_header, { class: "mb-2 text-h4" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _hoisted_2,
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_q_btn, {
                color: "primary",
                label: "Volver",
                onClick: _ctx.goBack
              }, null, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}